import React from "react";

import { Grid } from "@mui/material";

import SkeletonComponent from "../../../../../../../../../../components/Generic/Skeleton";
import useStyles from "./styles";

export const Skeleton = () => {
  const classes = useStyles();

  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <SkeletonComponent isLoading classesName={classes.skeleton}>
          <div />
        </SkeletonComponent>
      </Grid>
      <Grid item xs={12}>
        <SkeletonComponent isLoading classesName={classes.skeleton}>
          <div />
        </SkeletonComponent>
      </Grid>
      <Grid item xs={12}>
        <SkeletonComponent isLoading classesName={classes.skeleton}>
          <div />
        </SkeletonComponent>
      </Grid>
    </Grid>
  );
};
